export const GET_PART = 'GET_PART';
export const SUCCESS_GET_PART = 'SUCCESS_GET_PART';
export const FAIL_GET_PART = 'FAIL_GET_PART';

export const GET_ALL_PART = 'GET_ALL_PART';
export const SUCCESS_GET_ALL_PART = 'SUCCESS_GET_ALL_PART';
export const FAIL_GET_ALL_PART = 'FAIL_GET_ALL_PART';

export const ADD_PART = 'ADD_PART';
export const SUCCESS_ADD_PART = 'SUCCESS_ADD_PART';
export const FAIL_ADD_PART = 'FAIL_ADD_PART'
export const RESET_ADD_PART = 'RESET_ADD_PART';

export const DEL_PART = 'DEL_PART';
export const SUCCESS_DEL_PART = 'SUCCESS_DEL_PART';
export const FAIL_DEL_PART = 'FAIL_DEL_PART';

export const GET_CONTRACT = 'GET_CONTRACT';
export const SUCCESS_GET_CONTRACT = 'SUCCESS_GET_CONTRACT';
export const FAIL_GET_CONTRACT = 'FAIL_GET_CONTRACT';

export const GET_ALL_CONTRACT = 'GET_ALL_CONTRACT';
export const SUCCESS_GET_ALL_CONTRACT = 'SUCCESS_GET_ALL_CONTRACT';
export const FAIL_GET_ALL_CONTRACT = 'FAIL_GET_ALL_CONTRACT';

export const ADD_CONTRACT = 'ADD_CONTRACT';
export const SUCCESS_ADD_CONTRACT = 'SUCCESS_ADD_CONTRACT';
export const FAIL_ADD_CONTRACT = 'FAIL_ADD_CONTRACT';

export const DEL_CONTRACT = 'DEL_CONTRACT';
export const SUCCESS_DEL_CONTRACT = 'SUCCESS_DEL_CONTRACT';
export const FAIL_DEL_CONTRACT = 'FAIL_DEL_CONTRACT';



